var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("div", { class: ["sub-values", { inline: _vm.isInactive }] }, [
        _c(
          "div",
          {
            staticClass: "sub-value clickable",
            on: {
              click: function($event) {
                return _vm.$emit("click")
              }
            }
          },
          [
            _c("div", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.typeLabel))
            ]),
            _vm._v(" "),
            _vm.data.items
              ? _c(
                  "div",
                  _vm._l(_vm.data.items, function(item) {
                    return _c("div", { key: item.id }, [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(item.firstName) +
                          " " +
                          _vm._s(item.lastName) +
                          " (" +
                          _vm._s(item.yearOfBirth) +
                          ")\n\t\t\t"
                      )
                    ])
                  }),
                  0
                )
              : _vm._e()
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }